import React, { FC, useContext, useState } from 'react';
import { Direction } from '~/types';

const defaultDirection = 'ltr';
const DirectionContext = React.createContext<[Direction, (d: Direction) => void]>([
  defaultDirection,
  () => {},
]);

export const DirectionProvider: FC = (props) => {
  const { children } = props;
  const [state, setState] = useState<Direction>(defaultDirection);
  return (
    <DirectionContext.Provider value={[state, setState]}>{children}</DirectionContext.Provider>
  );
};

const useDirection = (): [Direction, (d: Direction) => void] => {
  return useContext(DirectionContext);
};

export default useDirection;
